import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { components } from "../components";
import { course as elements } from "../course";

export const CategoryList: React.FC = () => {
  const location = useLocation();
  const { pathname } = useLocation();

  const title = location.state.title;

  const [loading, setLoading] = useState(false);
  const [coursesData, setCoursesData] = useState<any>([]);

  const getData = async () => {
    setLoading(false);
    // try {
    //   const results = await Promise.allSettled([axios.get(URLS.GET_COURSES)]);

    //   const coursesResponse = properties;

    //   if (coursesResponse.status === 'fulfilled') {
    //     setCoursesData(coursesResponse?.properties);
    //   } else {
    //     // console.error('Error fetching courses:', coursesResponse.reason);
    //   }
    // } catch (error) {
    //   console.error('Unexpected error:', error);
    // } finally {
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  // Api call for fetch the properties

  useEffect(() => {
    const { title, propertyList } = location.state || {};
    // console.log(title, " title ");
    // console.log(propertyList, " propertyList");
    setCoursesData(propertyList);
  }, []);

  // Start Component here
  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={true}
        // filter={true}
        title={title}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    let sliceStart = 0;
    let sliceEnd = 15;

    if (title === "Recent Search") {
      sliceStart = 0;
      sliceEnd = 2;
    } else if (title === "Smart Suggestions") {
      sliceStart = 2;
      sliceEnd = 5;
    } else if (title === "Perfect Match") {
      sliceStart = 4;
      sliceEnd = 7;
    } else if (title === "Best for You") {
      sliceStart = 5;
      sliceEnd = 8;
    }
    // else if (title === "Budget-Friendly") {
    //   sliceStart = 6;
    //   sliceEnd = 9;
    // }
    else if (title === "Similar Properties") {
      sliceStart = 0;
      sliceEnd = 4;
    }

    const slicedCourses = coursesData?.slice?.(sliceStart, sliceEnd);

    return (
      <main style={{ paddingBottom: 0 }}>
        <div style={{ paddingTop: 10, paddingBottom: 20 }}>
          {coursesData?.map((course: any, index: number) => {
            const isLast = index === slicedCourses.length - 1;
            return (
              <elements.CourseCard
                key={index}
                course={course}
                isLast={isLast}
                section="category list"
              />
            );
          })}
        </div>
      </main>
    );
  };

  // const renderContent = (): JSX.Element => {
  //   return (
  //     <main style={{ paddingBottom: 0 }}>
  //       <div style={{ paddingTop: 10, paddingBottom: 20 }}>
  //         {coursesData.slice(1, 6).map((course: any, index: number, array: any) => {
  //           const isLast = index === array.length - 1;
  //           return (
  //             <elements.CourseCard
  //               key={index}
  //               course={course}
  //               isLast={isLast}
  //               section='category list'
  //             />
  //           );
  //         })}
  //       </div>
  //     </main>
  //   );
  // };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};

// old code  08-07-2025
// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { URLS } from '../config';
// import { components } from '../components';
// import { course as elements } from '../course';
// import properties from '../staticdata/properties';

// export const CategoryList: React.FC = () => {
//   const location = useLocation();
//   const { pathname } = useLocation();

//   const title = location.state.title;
//   // const title = "vikas kumar";

//   const [loading, setLoading] = useState(false);
//   const [coursesData, setCoursesData] = useState<any>([]);

//   const getData = async () => {
//     setLoading(false);

//     // try {
//     //   const results = await Promise.allSettled([axios.get(URLS.GET_COURSES)]);

//     //   const coursesResponse = properties;

//     //   if (coursesResponse.status === 'fulfilled') {
//     //     setCoursesData(coursesResponse?.properties);
//     //   } else {
//     //     // console.error('Error fetching courses:', coursesResponse.reason);
//     //   }
//     // } catch (error) {
//     //   console.error('Unexpected error:', error);
//     // } finally {
//     //   setLoading(false);
//     // }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   // Start Component here
//   const renderImageBackground = (): JSX.Element => {
//     return <components.Background version={1} />;
//   };

//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         goBack={true}
//         // filter={true}
//         title={title}
//       />
//     );
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main style={{ paddingBottom: 0 }}>
//         <div style={{ paddingTop: 10, paddingBottom: 20 }}>
//           {coursesData.map((course: any, index: number, array: any) => {
//             const isLast = index === array.length - 1;
//             return (
//               <elements.CourseCard
//                 key={index}
//                 course={course}
//                 isLast={isLast}
//                 section='category list'
//               />
//             );
//           })}
//         </div>
//       </main>
//     );
//   };

//   return (
//     <>

//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
